import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';
import { BRAND_INFO } from '../data/mock';

const SignInPage = () => {
  usePageTitle(`Sign in | ${BRAND_INFO.name}`, `Sign in to your ${BRAND_INFO.name} dashboard.`);

  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  return (
    <>
      <Header />
      <section className="pt-28 lg:pt-36 pb-24 bg-cream-100 min-h-[60vh]">
        <div className="container-tight">
          <div className="bg-cream-50 border border-cream-200 rounded-3xl p-8 lg:p-10">
            <p className="eyebrow">Account</p>
            <h1 className="mt-4 font-display text-display-md text-ink-900">Sign in.</h1>
            <p className="mt-3 text-ink-600">
              Enter your email and we&apos;ll send you a one-time link to sign in to your dashboard.
            </p>

            {!sent ? (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (email.trim()) setSent(true);
                }}
                className="mt-7 space-y-4"
              >
                <div>
                  <label className="block text-[12px] uppercase tracking-[0.16em] text-ink-500 mb-1.5">
                    Email
                  </label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 rounded-xl bg-white border border-cream-300"
                    placeholder="you@email.com"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full inline-flex items-center justify-center gap-2 bg-brick-500 hover:bg-brick-600 text-white font-medium px-5 py-3 rounded-full transition-colors"
                >
                  Send sign-in link <ArrowRight className="w-4 h-4" />
                </button>
              </form>
            ) : (
              <div className="mt-7 p-5 bg-sage-50 border border-sage-200 rounded-2xl flex items-start gap-3">
                <Mail className="w-5 h-5 text-sage-700 mt-0.5" />
                <div>
                  <div className="text-ink-900 font-medium">Check your inbox.</div>
                  <div className="text-[14px] text-ink-700 mt-1">
                    We sent a sign-in link to <span className="font-medium">{email}</span>. The
                    link expires in 15 minutes.
                  </div>
                </div>
              </div>
            )}

            <div className="mt-8 pt-6 border-t border-cream-200 text-[14px] text-ink-500">
              New to {BRAND_INFO.name}?{' '}
              <Link to="/panels" className="text-brick-500 hover:underline">
                Order your first panel →
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SignInPage;
